import styled from 'styled-components';

const List = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0px;
`;

export default List;
